import styled from "styled-components";
import { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Space,
  Modal,
  Pagination,
  notification,
  Tag,
} from "antd";
import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Card from "../../../Components/Backoffice/Card";
import Sidebar from "../../../Components/Backoffice/Sidebar";
import Header from "../../../Components/Backoffice/Header";
import Footer from "../../../Components/Backoffice/Footer";
import Title from "../../../Components/Backoffice/Title";

const Wrapper = styled.main`
  background-color: #e8e9f3;
  display: grid;
  grid-template-columns: 7.083vw 1fr;
  min-height: 100vh;
`;

const Content = styled.div`
  padding: 1.771vw;
`;

const GridCards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;

  .flex {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .item {
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    align-items: start;
  }

  .item__title {
    color: #494d7d;
    letter-spacing: 0px;
    font-size: 18px;
    font-weight: bold;
    line-height: 18px;
    text-align: left;
    width: fit-content;
  }
  .item__date {
    color: #ccc;
    letter-spacing: 0px;
    margin-top: 5px;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    width: fit-content;
    text-align: left;
  }

  .item__actions {
    display: flex;
    gap: 10px;
  }
`;

export default function EditorDashboard() {
  document.title = "SPAP - Editores de conteúdo";
  const token = JSON.parse(localStorage.getItem("session_data"))?.token;

  const navigate = useNavigate();
  const [editors, setEditors] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 9;
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editorToDelete, setEditorToDelete] = useState(null);

  useEffect(() => {
    fetchEditors();
  }, []);

  const fetchEditors = async () => {
    try {
      const response = await axios.get("https://api.spap.pt/api/editors/all");

      const editors = response.data.editor;
      const apresentacoes = response.data.apresentacoes; // ⬅️ tens de garantir que vem daqui (ou de outro endpoint)

      const enrichedEditors = editors.map((editor) => {
        // encontrar apresentações que usam este template
        const usedIn = apresentacoes.filter((ap) => {
          return String(ap.descricao) === String(editor.id);
        });

        console.log(usedIn);

        return {
          ...editor,
          usedInTitles: usedIn.map((ap) => ap.titulo),
          usedInCount: usedIn.length,
        };
      });
      setEditors(enrichedEditors);
      setCurrentItems(enrichedEditors.slice(0, itemsPerPage));
    } catch (err) {
      notification.error({ description: "Erro ao carregar os editors." });
    }
  };

  const handlePageChange = (page) => {
    const newOffset = (page - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentItems(editors.slice(newOffset, newOffset + itemsPerPage));
  };

  const handleCreate = () => {
    navigate("/builder");
  };

  const confirmDelete = (editor) => {
    setEditorToDelete(editor);
    setDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("session_data"))?.token;
      await axios.delete(`https://api.spap.pt/api/admin/editor/${editorToDelete.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const newEditors = editors.filter((e) => e.id !== editorToDelete.id);
      setEditors(newEditors);
      setCurrentItems(newEditors.slice(itemOffset, itemOffset + itemsPerPage));
      notification.success({ description: "Editor removido com sucesso!" });
    } catch (err) {
      notification.error({ description: "Erro ao remover o editor." });
    } finally {
      setDeleteModalOpen(false);
      setEditorToDelete(null);
    }
  };

  // Função utilitária
  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // meses começam do 0
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
    <Wrapper>
          <div>
            <Sidebar />
          </div>
      <Content>
        <Header />
        <Row align="middle" justify="space-between" style={{ marginBottom: 20 }}>
          <Title>Editores de Conteúdo</Title>
          <Col>
            <Button
              onClick={handleCreate}
              style={{
                background: "#494D7D",
                color: "#fff",
                borderRadius: "6px",
                height: "40px",
                display: "flex",
                fontWeight: "bold",
                alignItems: "center",
                padding: "0 30px",
              }}
            >
              <PlusOutlined /> Novo Editor
            </Button>
          </Col>
        </Row>
        {currentItems.length > 0 && (
          <GridCards>
          {currentItems.map((editor) => (
            <Card className="item" key={editor.id}>
              <div className="flex">
                <div className="item__title">{editor.name}</div>
                <div className="item__date">{formatDate(editor.updated_at)}</div>
              </div>
              <div>
                {editor.usedInTitles.map((title) => (
                  <Tag className="mt-2 mb-4" key={title}><b>Template utilizado em Apresentações:</b> {title}</Tag>
                ))}
                {editor.usedInTitles.length == 0 &&
                  <Tag className="mt-2 mb-4">Template não utilizado</Tag>
                }
                <div className="item__actions">
                  <Button
                    type="default"
                    onClick={() => navigate(`/builder/${editor.id}`)}
                    style={{ fontWeight: "bold" }}
                    icon={<EditOutlined />}
                  >
                    Editar
                  </Button>
                  <Button
                    type="primary"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => confirmDelete(editor)}
                  >Apagar</Button>
                </div>
              </div>
            </Card>
          ))}
          </GridCards>
        )}
        <Pagination
          style={{ marginTop: 20 }}
          current={itemOffset / itemsPerPage + 1}
          total={editors.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
        />
        <Footer />
        <Modal
          title="Confirmar remoção"
          open={deleteModalOpen}
          onOk={handleDelete}
          onCancel={() => setDeleteModalOpen(false)}
          okText="Sim"
          cancelText="Cancelar"
        >
          <p>
            Tem a certeza que quer remover o editor "
            {editorToDelete?.name}"?
          </p>
        </Modal>
      </Content>
    </Wrapper>
  );
}